<template>
  <div class="RefundCmp full-height linear-main3">
    <ld-header
      transparent
      white
      @click-left="$router.push({ path: '/allorder', query: { findType: '4' }})"
    >
      退票申请完成
    </ld-header>
    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <van-pull-refresh
          v-model="isLoading"
          @refresh="getDetail"
        >
          <div class="white pad8">
            <van-row class="font-lg font24 mt5">
              <ld-icon
                :type="detail.showSendApp == 1 ? 'iconshenpi1' : 'iconbanli'"
                size="30"
                class="order-status__icon"
              />
              {{ detail.refundStatusDesc }}
            </van-row>
            <van-row class="font12 mt5">
              {{ detail.refundStatusDescDetail }}
            </van-row>
          </div>

          <div
            class="pad8"
            v-if="detail.orderNo"
          >
            <van-row class="round-sm pad8 van-row bg-white">
              退票单号：{{ detail.orderNo }}

              <router-link
                class="main-color fr"
                :to="`/tr/RefundDetail/${detail.id}`"
              >
                {{ $t('B011','查看订单') }}
              </router-link>
            </van-row>

            <!-- 经停信息 -->
            <div class="round-sm mt5">
              <stop-station
                class="bg-white van-hairline--bottom"
                :detail="detail"
                train-no-class="main-color"
              />
            </div>

            <!-- 乘车人列表 -->
            <van-cell-group class="mt5 round-sm">
              <psg-panel
                :key="i"
                :passenger="detail.passenger"
              />
            </van-cell-group>

            <ld-button
              class="mt5"
              detault
              to="/home"
            >
              {{ $t('B012','继续预订') }}
            </ld-button>
          </div>
        </van-pull-refresh>
      </mescroll-vue>
    </div>

    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        class="full-width bg-white shadow"
        type="flex"
        align="center"
        @click="$refs['tabbar'].toggle()"
      >
        <van-col
          span="5"
          :offset="1"
        >
          应退金额：
        </van-col>
        <van-col span="6">
          <span class="font10 red">&yen;</span>
          <span class="font24 red">{{ detail.cuRefundAmount }}</span>
        </van-col>
        <van-col
          span="2"
          class="font12 text-right"
        >
          {{ $t('E006','明细') }}
        </van-col>
        <van-col
          span="2"
          class="text-center"
        >
          <van-icon
            name="arrow-up"
            class="vertical-middle"
            size="14"
          />
        </van-col>
        <van-col
          span="8"
          class="pad5"
        >
          <ld-button
            main
            size="md"
            v-if="detail.showSendApp == 1"
            @click.native="btnClick('approval')"
          >
            {{ $t('B028','送审') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>
  </div>
</template>

<script>
/**
 * @copyright (C), 2018-2019
 * @file 火车票退票完成页面
 * @param {String} id 火车票订单
 */
import { CellGroup, Cell, PullRefresh } from 'vant'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import StopStation from '../trQuery/StopStation'
import PsgPanel from '../trOrder/PsgPanel'
import handle from './handle'
import MescrollVue from 'mescroll.js/mescroll.vue'

import TrainOrderInteractor from 'Domain/use-cases/train-order-interactor'

export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [PullRefresh.name]: PullRefresh,
    ldButton,
    ldTabbar,
    StopStation,
    PsgPanel,
    MescrollVue
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      down:{use:false},
      isLoading: false,
      detail: {}, // 退单详情
      time: 5,
      timer: null
    }
  },
  created () {
    this.getDetail()
  },
  methods: {
    async getDetail() {
      this.isLoading = true
      
      const { data } = await TrainOrderInteractor.getRefundDetailById(this.id)
      
      this.isLoading = false
      this.detail = data
    },
    async btnClick (handleType) {
      if (handle[handleType]) {
        await handle[handleType](this.detail)
        this.getDetail()
      }
    }
  },
  computed: {
    priceList () {
      return [
        { name: '应退合计', price: this.detail.cuRefundAmount },
        { name: '成人', price: this.detail.ticketPrice },
        { name: '退票手续费', price: this.detail.cuRefundPoundage, amount: this.detail.ticketNumber || 1, unit: '人' },
        { name: '加收服务费', price: this.detail.sellServiceCharge, amount: this.detail.ticketNumber || 1, unit: '人' },
        { name: '退服务费', price: this.detail.refundServiceCharge, amount: this.detail.ticketNumber || 1, unit: '人' },
      ]
    }
  }
}
</script>

<style lang="less">
.RefundCmp {

  .wrapper {
    height: calc(100vh - 96px);
  }

  p {
    margin: 0;
  }

  .pad5 {
    padding: 5px;
  }

  .pad8 {
    padding: 8px;
  }

  .mt5 {
    margin-top: 5px;
  }

  .round-sm {
    overflow: hidden;
  }

  .order-status__icon {
    vertical-align: middle;
  }

  .StopStation {
    > .van-row {
      color: @color-text-black;
    }
  }
}
</style>